import { createSlice } from '@reduxjs/toolkit';
import services from '../services';
import { getErrorStatus } from '../getErrorStatus';

interface PublicState {
    data: any[];
    loading: boolean;
    error: boolean | { status?: number };
}

const initialState: PublicState = {
    data: [],
    loading: false,
    error: false,
};

const publicSlice = createSlice({
    name: 'public',
    initialState,
    reducers: {
        getPublic: (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        },
        getPublicSuccess: (state, actions) => {
            state.loading = false;
            state.error = false;
            state.data = actions.payload;
        },
        getPublicFailure: (state, actions) => {
            state.loading = false;
            state.error = actions.payload ? actions.payload : true;
            state.data = [];
        },
    },
});
export const { getPublic, getPublicSuccess, getPublicFailure } =
    publicSlice.actions;

export const fetchPublic =
    (body: any, page?: string, reverse_posts?: boolean) =>
    async (
        dispatch: (arg0: {
            payload: any;
            type:
                | 'public/getPublic'
                | 'public/getPublicSuccess'
                | 'public/getPublicFailure';
        }) => void
    ) => {
        dispatch(getPublic());
        try {
            const response = await services.getPublic(body, page, reverse_posts);
            if (response?.status < 300) {
                dispatch(getPublicSuccess(response.data));
            } else if (response?.status) {
                dispatch(getPublicFailure({ status: response.status }));
            } else {
                throw new Error(response);
            }
        } catch (err) {
            console.log('err: ', err);
            dispatch(
                getPublicFailure({
                    status: getErrorStatus(err),
                })
            );
        }
    };

export default publicSlice.reducer;
